// Condition preview client. UI POSTs the current draft IndicatorSpec list and gets
// back the flat condition list with names + indices the user can tick.

import { fetchJson, URLS } from "./client";
import type { IndicatorSpecDto } from "./types";

export interface ConditionPreviewEntry {
  index: number;
  id: string;
  name: string;
  description: string;
  bias: "bullish" | "bearish" | "neutral";
  indicatorInstanceKey: string;
}

export interface ConditionPreviewRequest {
  indicatorSpecs: IndicatorSpecDto[];
  useAdvanced?: boolean;
  usePriceAction?: boolean;
}

export function previewConditions(
  req: ConditionPreviewRequest,
  signal?: AbortSignal,
): Promise<ConditionPreviewEntry[]> {
  return fetchJson<ConditionPreviewEntry[]>(`${URLS.historicalIndicators}/Conditions/preview`, {
    method: "POST",
    body: req,
    signal,
  });
}
